import React, { memo } from 'react';

export default memo((props) => (
    <div>
      <i className="icon-info22" />
    </div>
));
